import general from 'Locales/es/generalTranslation.es.json'
import auth from 'Features/auth/locales/auth.es.json'
import dashboard from 'Features/home/locales/dashboard.es.json'
import accountSettings from 'Features/accountSettings/locales/accountSettings.es.json'
import userProfile from 'Features/userProfile/locals/userProfile.es.json'
import mainMenu from 'Features/mainMenu/locals/mainMenu.es.json'
import domainManagement from 'Features/domainsManagement/locals/domainManagment.es.json'
import underMaintenance from 'Features/underMaintenance/locales/underMaintenance.es.json'
import onboarding from 'Features/OnboardingWizard/locals/onboarding.es.json'
import home from 'Features/home/locales/home.es.json'
import googleAnalytics from 'Features/GoogleAnalyticsConnector/locales/googleAnalytics.es.json'
import checkout from 'Features/checkout/locales/checkout.es.json'
import pricing from 'Features/pricing/locals/pricing.es.json'
import errors from 'Locales/es/errors.es.json'
import scheduleCall from 'Features/ScheduleCallModal/locals/scheduleCall.es.json'
import limitedOfferBanner from 'Features/ClickceaseMigrationBanner/locales/limitedOfferBanner.es.json'
import helpCenterModal from 'Features/HelpCenterModal/locals/HelpCenterModal.es.json'
import botMitigation from 'Locales/es/botMitigation.es.json'
import PMDashboard from 'Locales/es/paidMarketing/dashboard.es.json'
import PMDetectionSettings from 'Locales/es/paidMarketing/detectionSettings.es.json'
import PMDomains from 'Locales/es/paidMarketing/domains.es.json'
import PMGeneral from 'Locales/es/paidMarketing/general.es.json'
import PMPlatforms from 'Locales/es/paidMarketing/platforms.es.json'

export const mergedEsTranslations = {
  ...{ general },
  ...{ auth },
  ...{ dashboard },
  ...{ accountSettings },
  ...{ userProfile },
  ...{ mainMenu },
  ...{ domainManagement },
  ...{ underMaintenance },
  ...{ onboarding },
  ...{ home },
  ...{ googleAnalytics },
  ...{ checkout },
  ...{ pricing },
  ...{ errors },
  ...{ scheduleCall },
  ...{ limitedOfferBanner },
  ...{ helpCenterModal },
  ...{ botMitigation },
  ...{ PMDashboard },
  ...{ PMDetectionSettings },
  ...{ PMDomains },
  ...{ PMGeneral },
  ...{ PMPlatforms },
}
